var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{class:['iconfont', _vm.props.type]})}
var staticRenderFns = []

export { render, staticRenderFns }